import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { format, parseISO } from 'date-fns';
import * as am5percent from "@amcharts/amcharts5/percent";
import {
    GetPostMethodData,
    DecryptAESdata,
} from "../../../../provider/ServiceProvider";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import animation from '../../../../images/jm-animation.gif'
import './MaturityProfile.css'

function MaturityProfile(props) {
    const [data, setData] = useState([]);
    const { BaseURL } = useContext(URLstateContext);
    const [chartdata, setchartdata] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);
    let getSchemeCodeIn = props.getSchemeCode;

    useEffect(() => {
        setloadingshow(true);
        GetPostMethodData(BaseURL + "GetFundMaturityProfile", {
            IVSchemeCode: getSchemeCodeIn,
        }).then((data) => {
            setloadingshow(false);
            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));

                setchartdata(DecryptAESdata(data.data))
                
                setloadingshow(false);
                console.log(DecryptAESdata(data.data))
            }
        });
    }, [BaseURL]);

    useLayoutEffect(() => {
        am5.addLicense("AM5C420959785"); 
        var root = am5.Root.new("MaturityChartDiv");

        root.setThemes([
            am5themes_Animated.new(root)
        ]);

        var chart = root.container.children.push(am5xy.XYChart.new(root, {
            panX: false,
            panY: false,
            layout: root.verticalLayout
        }));

        var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
        cursor.lineY.set("visible", false);

        var xRenderer = am5xy.AxisRendererX.new(root, { minGridDistance: 30 });
        xRenderer.labels.template.setAll({
            rotation: -40,
            centerY: am5.p100,
            centerX: am5.p50,
            fontSize: 10
        });

        var xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
            categoryField: "country",
            renderer: xRenderer,
            tooltip: am5.Tooltip.new(root, {})
        }));

        var yRenderer = am5xy.AxisRendererY.new(root, {})
        yRenderer.labels.template.set('visible', false)

        var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
            renderer: yRenderer
        }));

        yAxis.get("renderer").grid.template.setAll({
            strokeWidth: 0,
            visible: false
        });

        xAxis.get("renderer").grid.template.setAll({
            location: 0,
            strokeWidth: 0,
            visible: false
        });

        var series = chart.series.push(am5xy.ColumnSeries.new(root, {
            name: "Series 1",
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: "value",
            stroke: am5.color(0x2a4e96),
            categoryXField: "country",
            tooltip: am5.Tooltip.new(root, {
                labelText: "{valueY}"
            })
        }));


        series.set("fill", am5.color(0x2a4e96));

        function generateChartData() {
            let chartData = [];
            if (data != null && data != []) {
                for (var i = 0; i < data.length; i++) {
                    chartData.push({
                        country: data[i].Maturity,
                        value: data[i].PercentToAss,
                    });
                }
            }
            return chartData;
        }

        let datanew = generateChartData();

        series.columns.template.setAll({
            width: 25
        });

        xAxis.data.setAll(datanew);
        series.data.setAll(datanew);

        series.appear(1000);
        chart.appear(1000, 100);

        return (() => {
            root.dispose();
        })
    }, [data])


    return (
        <>
            <div className="gradiant-head-box">
                <div className="gradiant-head-container">
                    <h3 className="gradiant-head left">Maturity Profile</h3>
                </div>
                <div className="gradiant-content">
                    <div className="padding-box-inner paddingChart">
                    {(data && data.length === 0) ? <h6 className="maturityerrorMsg" role="alert">No Data Found !!!</h6> : ''}
                        {loadingshow ? <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
                            <img src={animation} alt="" aria-hidden="true" />
                            <div className="model_popup">Please Wait...</div>
                        </div> : ""
                        }
                        <div id="MaturityChartDiv" style={{ width: "100%", height: "335px" }}></div>
                    </div>
                </div>

            </div>

        </>
    )
}

export default MaturityProfile